import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function highlightParallax() {
  const items = document.querySelectorAll('.js-highlight-item');

  items.forEach((item) => {
    const thumb = item.querySelector('.js-highlight-item-thumb');
    const bg = item.querySelector('.js-highlight-item-bg');

    if (!thumb || !bg) return;

    // thumbは初期状態で40px上から始まり、下にスクロールすると下に移動
    gsap.fromTo(
      thumb,
      {
        y: -60,
      },
      {
        y: -40,
        ease: 'power2.inOut',
        scrollTrigger: {
          trigger: item,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 3,
        },
      }
    );

    // bgは初期状態で40px下から始まり、下にスクロールすると上に移動
    gsap.fromTo(
      bg,
      {
        y: -40,
      },
      {
        y: -60,
        ease: 'power2.inOut',
        scrollTrigger: {
          trigger: item,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 3,
        },
      }
    );
  });
}
